export default "__VITE_ASSET__BHmf$kT7__"